<button
  pButton
  type="button"
  icon="pi pi-history"
  label="История изменений"
  class="p-button-secondary p-button-text"
  (click)="op.toggle($event)"></button>
<p-overlayPanel
  #op
  styleClass="p-0 xl:w-4 lg:w-6 md:w-8 sm:w-10 w-full dropdown-overlay-panel"
  (onShow)="loadHistory()"
  (onHide)="hideHistory()"
  (click)="op.show($event)">
  <ng-template pTemplate="">
    <div
      class="overflow-y-auto"
      (scroll)="onScrollEndHistory($any($event.target))"
      style="height: 300px">
      <crm-spinner *ngIf="loadingHistory"></crm-spinner>
      <ng-container *ngIf="!loadingHistory">
        <div
          *ngFor="let history of historyItems"
          class="p-2">
          <div class="text-400 text-sm">{{ history?.created | date: 'dd MMMM yyyy HH:mm' }}</div>
          <a
            *ngIf="history?.user"
            routerLink="/user/card/{{ history?.user?.id }}"
            target="_blank"
            >{{ history?.user?.profile?.name }}</a
          >
          <span>
            {{ history?.name }} в "<a
              (click)="showFinance(history.target); op.hide()"
              class="cursor-pointer"
              >{{ history?.target?.name }}</a
            >": c "{{ history?.oldValue }}" на "{{ history?.newValue }}"
          </span>
        </div>
      </ng-container>
      <div
        *ngIf="paginationLoadingHistory"
        class="text-center">
        <p-progressSpinner
          [style]="{
            width: '50px',
            height: '50px'
          }"></p-progressSpinner>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
